import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTigerdataLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 141,
	height: 30,
	fill: "none",
	viewBox: "0 0 141 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "tigerdata-logo-45f8ce_a",
			width: 31,
			height: 30,
			x: 0,
			y: 0,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "luminance" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M30.338 14.981C30.338 6.707 23.623 0 15.34 0S.345 6.707.345 14.981v.038C.345 23.293 7.059 30 15.34 30s14.997-6.707 14.997-14.981z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#tigerdata-logo-45f8ce_a)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#tigerdata-logo-45f8ce_b)",
					d: "m13.406 13.501-.001-2.472a.56.56 0 0 0-.163-.392l-2.139-2.144L9.61 10.14l3.489 3.489a.18.18 0 0 0 .308-.128"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "url(#tigerdata-logo-45f8ce_c)",
					d: "m8.68 19.462-4.204-4.197-1.503 1.633 5.562 5.558a.18.18 0 0 0 .308-.128v-2.474a.56.56 0 0 0-.163-.392"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "currentColor",
					d: "M14.281.091C6.735.613.704 6.861.42 14.421c-.278 7.382 4.797 13.628 11.65 15.16l-9.136-9.138a.7.7 0 0 1-.204-.494l.007-2.953c0-.123.15-.185.237-.097l1.502-1.633a.24.24 0 0 1 0-.342l1.446-1.442a.24.24 0 0 1 .34 0l4.884 4.884c.207.208.324.49.324.783v5.096c0 .734.291 1.438.81 1.957l3.724 3.724c.945-.04 1.867-.17 2.759-.378l-4.717-4.72a1.25 1.25 0 0 1-.364-.88v-4.925a3.04 3.04 0 0 0-.892-2.152l-4.956-4.957a.24.24 0 0 1 0-.342L9.27 10.14a.24.24 0 0 1 .34 0l1.493-1.647a2 2 0 0 1-.08-.103c-.427-.576-.686-1.524-.384-2.594.181-.685.557-1.202 1.25-1.83a.17.17 0 0 1 .219-.004l1.794 1.555.353.307c.136.118.298.201.473.242l5.593 1.33a.37.37 0 0 1 .173.095l5.745 5.733c.1.096.158.23.158.37v1.218c0 .188-.048.372-.138.536l-2.843 5.182a.5.5 0 0 1-.638.219l-1.31-.572h-4.79a.557.557 0 0 0-.558.557v2.137c0 .294.116.576.324.785l4.96 5c5.225-2.327 8.869-7.568 8.869-13.66 0-8.604-7.267-15.51-15.993-14.906z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M44.26 21.821h-2.741V9.461H36.97V7.026h11.836v2.437H44.26zm8.885 0h-2.72V11.319h2.72zm7.13 4.3c-3.018 0-5.083-1.427-5.083-3.725h2.68c.02.871.954 1.565 2.384 1.565 1.708 0 2.601-.99 2.601-2.457v-1.387c-.635.97-1.747 1.546-3.197 1.546-2.86 0-4.865-2.18-4.865-5.33 0-3.171 2.025-5.35 4.825-5.35 1.629 0 2.94.733 3.555 1.882l.219-1.546h2.144v10.165c0 2.814-2.065 4.637-5.262 4.637m-.079-6.678c1.57 0 2.661-1.268 2.661-3.13 0-1.823-1.092-3.091-2.66-3.091-1.55 0-2.642 1.268-2.642 3.11 0 1.843 1.092 3.111 2.641 3.111m12.512 2.695c-3.277 0-5.52-2.279-5.52-5.528 0-3.408 2.263-5.628 5.321-5.628 3.019 0 5.084 2.12 5.144 5.549v.634h-7.805c.199 1.624 1.291 2.734 2.88 2.734 1.112 0 1.926-.515 2.264-1.427h2.621c-.576 2.319-2.383 3.666-4.905 3.666m-2.74-6.777h4.904c-.297-1.347-1.131-2.12-2.363-2.12s-2.184.793-2.542 2.12m12.034 6.46h-2.72V11.319h2.184l.338 2.1c.675-1.466 1.906-2.238 3.634-2.238h.437v2.615h-.437c-2.165 0-3.436 1.11-3.436 3.012zm15.514 0h-5.084V7.951h5.084c4.19 0 7.129 2.814 7.129 6.856 0 4.14-2.939 7.014-7.129 7.014m-2.343-11.433v8.976h2.522c2.423 0 4.11-1.863 4.11-4.557 0-2.556-1.687-4.42-4.11-4.42zm14.772 11.69c-2.443 0-4.072-1.129-4.052-3.13.04-2.477 2.523-3.032 4.568-3.27 1.549-.198 2.642-.297 2.642-1.11 0-.871-.657-1.426-1.908-1.426-1.31 0-2.184.694-2.323 1.724h-2.74c.238-2.298 2.304-3.884 5.103-3.884 2.96 0 4.509 1.546 4.509 3.765v4.577c0 .298.138.456.496.456h.556v2.041h-1.212c-1.013 0-1.728-.376-1.985-1.09a2 2 0 0 1-.14-.376c-.615 1.07-1.747 1.724-3.514 1.724m.596-2.06c1.409 0 2.562-.733 2.562-1.982v-1.525c-.359.614-1.292.753-2.324.891-1.251.179-2.166.357-2.166 1.348 0 .812.637 1.268 1.928 1.268m13.626 1.803h-1.43c-2.402 0-3.713-1.15-3.713-3.31v-4.913h-1.769V11.32h1.769V7.733h2.721v3.586h2.64v2.279h-2.64v4.656c0 .833.416 1.288 1.231 1.288h1.191zm5.326.258c-2.443 0-4.071-1.13-4.051-3.131.04-2.477 2.522-3.032 4.567-3.27 1.549-.198 2.642-.297 2.642-1.11 0-.871-.656-1.426-1.908-1.426-1.31 0-2.183.694-2.323 1.724h-2.74c.238-2.298 2.304-3.884 5.104-3.884 2.959 0 4.508 1.546 4.508 3.765v4.577c0 .298.139.456.496.456h.557v2.041h-1.211c-1.013 0-1.729-.376-1.987-1.09a2 2 0 0 1-.138-.376c-.616 1.07-1.749 1.724-3.516 1.724m.596-2.061c1.41 0 2.562-.733 2.562-1.982v-1.525c-.358.614-1.291.753-2.324.891-1.251.179-2.164.357-2.164 1.348 0 .812.635 1.268 1.926 1.268M51.7 10.04a1.577 1.577 0 1 0 .002-3.155 1.577 1.577 0 0 0-.001 3.155"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tigerdata-logo-45f8ce_b",
			x1: 13.442,
			x2: 11.024,
			y1: 11.106,
			y2: 11.07,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "currentColor",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "currentColor"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "tigerdata-logo-45f8ce_c",
			x1: 8.792,
			x2: 5.778,
			y1: 18.887,
			y2: 18.887,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "currentColor",
				stopOpacity: 0
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .96,
				stopColor: "currentColor"
			})]
		})] })
	]
});
export default SvgTigerdataLogo;
